// Utils
import findFirstDomAncestor from '../../../utils/dom/findFirstDomAncestor';
import getSelectionRect from '../../../utils/dom/getSelectionRect';

const isDiv = (node) => node && node.nodeName === 'DIV';
const isMilanoteElementDiv = (node) => node?.classList?.contains('Element');

/**
 * Gets the bounding rectangle for the current line that's being edited.
 * NOTE: At this stage, it's using the extremities of the element, as this made more
 *      sense while scrolling tabbed lines into view.
 */
const getTextSelectionCaretRect = () => {
    const boundingRect = getSelectionRect();

    if (!boundingRect) return null;

    const selection = window.getSelection();
    let parentDiv = findFirstDomAncestor(isMilanoteElementDiv)(selection.focusNode);
    parentDiv = parentDiv || findFirstDomAncestor(isDiv)(selection.focusNode);

    if (!parentDiv) return boundingRect;

    const parentDivBoundingRect = parentDiv.getBoundingClientRect();

    return {
        x: parentDivBoundingRect.x || parentDivBoundingRect.left,
        y: boundingRect.y || boundingRect.top,
        top: boundingRect.top,
        width: parentDivBoundingRect.width,
        height: boundingRect.height,
        right: parentDivBoundingRect.right,
        bottom: boundingRect.bottom,
        left: parentDivBoundingRect.left,
    };
};

export default getTextSelectionCaretRect;
